module.exports = __webpack_public_path__ + "static/media/image_brown@2x-min.e8b6828b.jpg";